import React, { useEffect, useState, useRef } from 'react';
import Layout from '../../../app/Layout';
import HeaderContent from '../General/HeaderContent';
import Breadcrumb from '../General/Breadcrumb';
import SpinnerLoading from '../../components/Spinners/SpinnerLoading';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  obtenerInfoControl,
  guardarSesionCapacitacionActivo,
  guardarPonenteTentativo,
  guardarTentativoConfirmado,
  eliminarDocenteTentativoConfirmado,
  agregarNuevaImagen,
  agregarNuevaEvidencia,
  eliminarImagen,
  eliminarEvidencia,
  agregarLinkDrive,
  cambiarEstadoDocente,

  actualizarEstadoAjuste,
  guardarDatosForm,
  registrarHistorialImplementacion,
  obtenerHistorialSesion,
  cambiarEstadoPubli,
  obtenerDesempenoDocente,
  guardarDesempenoDocente,
  cambiarFechaCapacitacion,
} from '../../../actions/controlCapacitacionesActions';
import { updateStateModalLarge, updateStateModalBasic } from '../../../actions/modalActions';
import ControlInsercionDocentesCapacitacion from '../../../containers/ControlInsercionDocentesCapacitacion';
import FormularioDatosCorreo from '../Docentes/FormularioDatosCorreo';
import { Modal, Button, Badge, Tabs, Tab, Form, Col, Row } from 'react-bootstrap';
import * as moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircle, faEye, faSync, faClock, faCommentDots,
  faInfoCircle, faUser, faGraduationCap, faTasks, faComments, faStar,
  faPaperclip, faExclamationTriangle, faFolderOpen, faVideo, faLink,
  faCheck, faCopy, faEnvelope, faMobileAlt, faUpload, faPlus,
  faHistory, faUserSlash, faUserCheck, faHandshake, faHeartbeat,
  faUsers, faFlag
} from '@fortawesome/free-solid-svg-icons';
import { avisoError, avisoCorrecto } from '../../components/AvisosMensajes/MensajesSwalf';

// ─── Constantes ──────────────────────────────────────────────────────────────

const COLOR_SEMAFORO = { VERDE: '#18BB60', AMBAR: '#F39C12', ROJO: '#E12E1C' };
const LABEL_SEMAFORO = { VERDE: 'Verde', AMBAR: 'Ámbar', ROJO: 'Rojo' };
const NO_CUENTA = ['La Actividad'];
const ESTADOS_CAPACITACION = [
  { id: 1, label: 'Pendiente',  variant: 'secondary' },
  { id: 2, label: 'Programada', variant: 'warning'   },
  { id: 3, label: 'Realizada',  variant: 'success'   },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

const calcularAvance = (proceso) => {
  if (!proceso || !proceso.length) return 0;
  const items = proceso.filter(p => !NO_CUENTA.includes(p.nombre_proceso));
  const completos = items.filter(p => p.estado === 'Completo').length;
  return Math.round((completos / 5) * 100);
};

const calcularSemaforo = (record) => {
  const tieneDocConfirmado = record.docente_confirmado && record.docente_confirmado.length > 0;
  const tieneEvidencia     = record.archivo_confirmacion && record.archivo_confirmacion.length > 0;
  const avance             = calcularAvance(record.proceso);
  if (!tieneDocConfirmado && !tieneEvidencia && avance === 0) return 'ROJO';
  if (tieneDocConfirmado && tieneEvidencia && avance === 100)  return 'VERDE';
  return 'AMBAR';
};

const badgeDocente = (record) => {
  if (record.docente_confirmado && record.docente_confirmado.length > 0)
    return <Badge variant="success">Confirmado</Badge>;
  if (record.docentes_tentativos && record.docentes_tentativos.length > 0)
    return <Badge variant="warning">Tentativo</Badge>;
  return <Badge variant="danger">Sin docente</Badge>;
};

// ─── Fila de docente (tabla de ponentes) ─────────────────────────────────────

const DocenteRow = ({ docente, idProyecto }) => {
  const dispatch    = useDispatch();
  const desempeno   = useSelector(s => s.control_capacitacion.desempenoDocentes?.[docente.id_filtro_docente] || {});
  const { usuario } = useSelector(s => s.usuario);

  const [clasificacion, setClasificacion] = useState(String(docente.id_estado_capacitacion || '1'));
  const [puntualidad,   setPuntualidad]   = useState('');
  const [claridad,      setClaridad]      = useState('');
  const [editable,      setEditable]      = useState(true);
  const hoy = new Date().toISOString().split('T')[0];
  const [fechaCap, setFechaCap] = useState(docente.fecha_capacitacion || '');

  useEffect(() => {
    if (docente.id_filtro_docente) {
      dispatch(obtenerDesempenoDocente(docente.id_filtro_docente));
    }
  }, [docente.id_filtro_docente, dispatch]);

  useEffect(() => {
    setPuntualidad(desempeno.puntualidad || '');
    setClaridad(desempeno.claridad || '');
    setEditable(!desempeno.puntualidad && !desempeno.claridad);
  }, [desempeno]);

  const handleGuardar = () => {
    if (!puntualidad || !claridad) {
      avisoError('Debes seleccionar opciones para Puntualidad y Claridad.');
      return;
    }
    if (editable) {
      dispatch(guardarDesempenoDocente(docente.id_filtro_docente, puntualidad, claridad));
      setEditable(false);
    } else {
      setEditable(true);
    }
  };

  const isGuardarDisabled = !['2', '3', '4'].includes(clasificacion);

  return (
    <tr>
      <td style={{ fontSize: 13 }}>{docente.nombre_usuario} {docente.apellido_usuario}</td>
      <td className="text-center">
        <div className="d-flex justify-content-center align-items-center" style={{ gap: 10 }}>
          <FontAwesomeIcon
            icon={faFlag}
            style={{ color: docente.publicitado !== '0' ? '#E12E1C' : '#ccc', cursor: 'pointer', fontSize: 14 }}
            title={docente.publicitado !== '0' ? 'Publicitado' : 'No publicitado'}
            onClick={() => dispatch(cambiarEstadoPubli(
              docente.id_filtro_docente,
              docente.publicitado === '1' ? '0' : '1',
              idProyecto
            ))}
          />
          <FontAwesomeIcon
            icon={faEnvelope}
            style={{ cursor: 'pointer', fontSize: 14, color: '#262F48' }}
            title="Enviar correo"
            onClick={() => {
              if (usuario.id_tp_nivel_usuario === '4' || usuario.id_tp_nivel_usuario === '1') {
                dispatch(updateStateModalBasic(
                  <FormularioDatosCorreo docente={docente} ctrl_cc={true} />,
                  'Nuevo Correo'
                ));
              } else {
                avisoError('El usuario no cuenta con permisos');
              }
            }}
          />
        </div>
      </td>
      <td>
        <select
          className="form-control form-control-sm"
          value={clasificacion}
          onChange={e => {
            const v = e.target.value;
            setClasificacion(v);
            if (v === '3' && !fechaCap) setFechaCap(hoy);
            if (v !== '3') setFechaCap('');
            dispatch(cambiarEstadoDocente(docente.id_filtro_docente, v, idProyecto));
          }}
        >
          <option value="1">Ninguno</option>
          <option value="2">Invitado</option>
          <option value="3">Confirmado</option>
          <option value="4">Contratado</option>
        </select>
        {clasificacion === '3' && (
          <input
            type="date"
            className="form-control form-control-sm mt-1"
            value={fechaCap}
            max={hoy}
            onChange={e => setFechaCap(e.target.value)}
            onBlur={e => {
              if (e.target.value) dispatch(cambiarFechaCapacitacion(docente.id_filtro_docente, e.target.value, idProyecto));
            }}
          />
        )}
      </td>
      <td>
        <select className="form-control form-control-sm" value={puntualidad}
          onChange={e => setPuntualidad(e.target.value)} disabled={!editable}>
          <option value="">-</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
      </td>
      <td>
        <select className="form-control form-control-sm" value={claridad}
          onChange={e => setClaridad(e.target.value)} disabled={!editable}>
          <option value="">-</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
      </td>
      <td className="text-center">
        <button className="btn btn-primary btn-sm" onClick={handleGuardar} disabled={isGuardarDisabled}>
          {editable ? 'Guardar' : 'Actualizar'}
        </button>
      </td>
    </tr>
  );
};

// ─── Componente principal ────────────────────────────────────────────────────

const ImplementacionDetalle = () => {
  const { idProyecto } = useParams();
  const dispatch = useDispatch();
  const { area_trabajo } = useSelector(s => s.control_capacitacion);
  const usuarioActual    = useSelector(s => s.usuario.usuario);
  const loading       = area_trabajo.loading;
  const datos         = area_trabajo.datos[idProyecto];
  const sesiones      = datos ? datos.tabla_sesiones : [];
  const sesionActiva  = area_trabajo.activo;

  // Historial
  const [historial,        setHistorial]        = useState([]);
  const [loadingHistorial, setLoadingHistorial]  = useState(false);
  // Modal motivar
  const [showMotivar,  setShowMotivar]  = useState(false);
  const [msgMotivar,   setMsgMotivar]   = useState('');

  const docentesFiltro = datos ? (datos.docentes_filtro || []) : [];
  const nombreProducto = datos?.datos_proyecto?.nombre_proyecto || '';

  const [showModal, setShowModal]   = useState(false);
  const [tabActiva, setTabActiva]     = useState('datos');
  const [paginaActiva, setPaginaActiva] = useState('sesiones');

  // Filtros tabla
  const [filtroSemaforo,    setFiltroSemaforo]    = useState('todos');
  const [filtroBusqueda,    setFiltroBusqueda]    = useState('');
  const [filtroEstadoDoc,   setFiltroEstadoDoc]   = useState('todos');
  const [filtroAvance,      setFiltroAvance]      = useState('todos');
  const [filtroFechaDesde,  setFiltroFechaDesde]  = useState('');
  const [filtroFechaHasta,  setFiltroFechaHasta]  = useState('');

  // Ordenamiento tabla
  const [sortCol, setSortCol] = useState('fecha_sesion');
  const [sortDir, setSortDir] = useState('asc');

  const handleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };

  // Buscador docentes en modal
  const [buscarDocente, setBuscarDocente] = useState('');

  // Drive link
  const [linkDrive, setLinkDrive] = useState('');
  const [editDrive, setEditDrive] = useState(false);

  // Refs archivos
  const refConfirmacion = useRef();
  const refEvidCap      = useRef();
  const refEvidCal      = useRef();

  useEffect(() => {
    if (!(idProyecto in area_trabajo.datos)) {
      dispatch(obtenerInfoControl(idProyecto));
    }
  }, [idProyecto]);

  const refrescar = () => dispatch(obtenerInfoControl(idProyecto));

  const logHistorial = (idSesion, tipoAccion, descripcion) => {
    dispatch(registrarHistorialImplementacion({
      id_sesion:   idSesion,
      id_proyecto: idProyecto,
      id_usuario:  usuarioActual?.id_usuario || null,
      tipo_accion: tipoAccion,
      descripcion: descripcion,
    }));
  };

  const cargarHistorial = async (idSesion) => {
    setLoadingHistorial(true);
    const data = await dispatch(obtenerHistorialSesion(idSesion));
    setHistorial(Array.isArray(data) ? data : []);
    setLoadingHistorial(false);
  };

  const abrirDetalle = (sesion) => {
    dispatch(guardarSesionCapacitacionActivo(sesion.id_sesion, idProyecto));
    setLinkDrive(sesion.link_drive || '');
    setEditDrive(false);
    setTabActiva('datos');
    setHistorial([]);
    setBuscarDocente('');
    setShowModal(true);
    cargarHistorial(sesion.id_sesion);
  };

  // ── Filtrado ──────────────────────────────────────────────────────────────
  const sesionesFiltradas = (Array.isArray(sesiones) ? sesiones : Object.values(sesiones)).filter(s => {
    const sem    = calcularSemaforo(s);
    const avance = calcularAvance(s.proceso);

    if (filtroSemaforo !== 'todos' && sem !== filtroSemaforo) return false;

    if (filtroBusqueda) {
      const q       = filtroBusqueda.toLowerCase();
      const modulo  = s.nombre_modulo?.toLowerCase() || '';
      const docConf = s.docente_confirmado?.[0];
      const docTent = s.docentes_tentativos?.[0];
      const docente = docConf
        ? `${docConf.nombre_usuario} ${docConf.apellido_usuario}`.toLowerCase()
        : docTent ? `${docTent.nombre_usuario} ${docTent.apellido_usuario}`.toLowerCase() : '';
      const sesion  = s.nombre_sesion?.toLowerCase() || '';
      if (!modulo.includes(q) && !docente.includes(q) && !sesion.includes(q)) return false;
    }

    if (filtroEstadoDoc !== 'todos') {
      const tieneConf = s.docente_confirmado && s.docente_confirmado.length > 0;
      const tieneTent = s.docentes_tentativos && s.docentes_tentativos.length > 0;
      if (filtroEstadoDoc === 'confirmado'   && !tieneConf)              return false;
      if (filtroEstadoDoc === 'tentativo'    && (!tieneTent || tieneConf)) return false;
      if (filtroEstadoDoc === 'sin_docente'  && (tieneConf || tieneTent)) return false;
    }

    if (filtroAvance !== 'todos') {
      if (filtroAvance === 'completo'   && avance !== 100) return false;
      if (filtroAvance === 'incompleto' && avance === 100) return false;
      if (filtroAvance === 'sin_avance' && avance !== 0)   return false;
    }

    if (filtroFechaDesde && s.fecha_sesion) {
      if (moment(s.fecha_sesion).isBefore(moment(filtroFechaDesde), 'day')) return false;
    }
    if (filtroFechaHasta && s.fecha_sesion) {
      if (moment(s.fecha_sesion).isAfter(moment(filtroFechaHasta), 'day')) return false;
    }

    return true;
  }).sort((a, b) => {
    let valA, valB;
    if (sortCol === 'fecha_sesion') {
      valA = a.fecha_sesion ? new Date(a.fecha_sesion) : new Date(0);
      valB = b.fecha_sesion ? new Date(b.fecha_sesion) : new Date(0);
    } else if (sortCol === 'avance') {
      valA = calcularAvance(a.proceso);
      valB = calcularAvance(b.proceso);
    } else if (sortCol === 'calificacion') {
      valA = parseFloat(a.calificacion) || 0;
      valB = parseFloat(b.calificacion) || 0;
    } else return 0;
    return sortDir === 'asc' ? (valA > valB ? 1 : -1) : (valA < valB ? 1 : -1);
  });

  // ── Contadores semáforo ───────────────────────────────────────────────────
  const todosArr = Array.isArray(sesiones) ? sesiones : Object.values(sesiones);
  const cntVerde = todosArr.filter(s => calcularSemaforo(s) === 'VERDE').length;
  const cntAmbar = todosArr.filter(s => calcularSemaforo(s) === 'AMBAR').length;
  const cntRojo  = todosArr.filter(s => calcularSemaforo(s) === 'ROJO').length;

  // ── Handlers ──────────────────────────────────────────────────────────────

  const handleConfirmar = (idFiltroSesion) => {
    dispatch(guardarTentativoConfirmado(idFiltroSesion, idProyecto)).then(() => {
      logHistorial(sesionActiva.id_sesion, 'DOCENTE_CONFIRMADO', 'Docente confirmado para la sesión');
      refrescar();
      cargarHistorial(sesionActiva.id_sesion);
      setTabActiva('docente');
      avisoCorrecto('Docente confirmado. Recuerda adjuntar la evidencia del correo de confirmación.');
    });
  };

  const handleEliminarDocente = (idFiltroSesion, nombreDocente) => {
    if (!window.confirm(`¿Quitar a ${nombreDocente} de los docentes tentativos?`)) return;
    dispatch(eliminarDocenteTentativoConfirmado(idFiltroSesion));
    logHistorial(sesionActiva.id_sesion, 'DOCENTE_ELIMINADO', `Docente tentativo ${nombreDocente} eliminado`);
    setTimeout(() => { refrescar(); cargarHistorial(sesionActiva.id_sesion); }, 600);
  };

  const handleCambiarDocente = () => {
    const docConf = sesionActiva?.docente_confirmado?.[0];
    if (!docConf) return;
    if (!window.confirm(`¿Cambiar docente? Se quitará a ${docConf.nombre_usuario} ${docConf.apellido_usuario} para asignar uno nuevo.`)) return;
    dispatch(eliminarDocenteTentativoConfirmado(docConf.id_filtro_sesion));
    logHistorial(sesionActiva.id_sesion, 'CAMBIO_DOCENTE', `Docente ${docConf.nombre_usuario} ${docConf.apellido_usuario} reemplazado`);
    setTimeout(() => { refrescar(); cargarHistorial(sesionActiva.id_sesion); }, 600);
  };

  const handleTerminarContrato = () => {
    const docConf = sesionActiva?.docente_confirmado?.[0];
    if (!docConf) return;
    if (!window.confirm(`¿Terminar contrato con ${docConf.nombre_usuario} ${docConf.apellido_usuario}?`)) return;
    dispatch(eliminarDocenteTentativoConfirmado(docConf.id_filtro_sesion));
    logHistorial(sesionActiva.id_sesion, 'CONTRATO_TERMINADO', `Contrato terminado con ${docConf.nombre_usuario} ${docConf.apellido_usuario}`);
    setTimeout(() => { refrescar(); cargarHistorial(sesionActiva.id_sesion); }, 600);
  };

  const handleMotivarDocente = () => {
    const docConf = sesionActiva?.docente_confirmado?.[0];
    if (!docConf || !msgMotivar.trim()) return;
    logHistorial(sesionActiva.id_sesion, 'MOTIVACION_DOCENTE', msgMotivar);
    avisoCorrecto('Motivación registrada en el historial');
    setMsgMotivar('');
    setShowMotivar(false);
    cargarHistorial(sesionActiva.id_sesion);
  };

  const handleSubirConfirmacion = (e) => {
    const file = e.target.files[0];
    if (!file || !sesionActiva) return;
    const fd = new FormData();
    fd.append('archivo', file);
    fd.append('id_sesion', sesionActiva.id_sesion);
    dispatch(agregarNuevaImagen(fd, idProyecto)).then(() => {
      logHistorial(sesionActiva.id_sesion, 'EVIDENCIA_CONFIRMACION', `Evidencia de confirmación adjuntada: ${file.name}`);
      refrescar();
      cargarHistorial(sesionActiva.id_sesion);
    });
  };

  const handleSubirEvidencia = (e) => {
    const file = e.target.files[0];
    if (!file || !sesionActiva) return;
    const fd = new FormData();
    fd.append('archivo', file);
    fd.append('id_sesion', sesionActiva.id_sesion);
    dispatch(agregarNuevaEvidencia(fd, idProyecto)).then(() => {
      logHistorial(sesionActiva.id_sesion, 'EVIDENCIA_CAPACITACION', `Evidencia de capacitación adjuntada: ${file.name}`);
      refrescar();
      cargarHistorial(sesionActiva.id_sesion);
    });
  };

  const handleSubirEvidenciaCalidad = (e) => {
    const file = e.target.files[0];
    if (!file || !sesionActiva) return;
    const fd = new FormData();
    fd.append('archivo', file);
    fd.append('id_sesion', sesionActiva.id_sesion);
    dispatch(agregarNuevaEvidencia(fd, idProyecto)).then(() => {
      logHistorial(sesionActiva.id_sesion, 'EVIDENCIA_CALIDAD', `Evidencia de calidad adjuntada: ${file.name}`);
      refrescar();
      cargarHistorial(sesionActiva.id_sesion);
    });
  };

  const handleGuardarDrive = () => {
    if (!sesionActiva) return;
    if (!linkDrive.trim()) {
      avisoError('Ingresa un link de Drive válido');
      return;
    }
    dispatch(agregarLinkDrive({
      idSesion:  sesionActiva.id_sesion,
      idDocente: sesionActiva.id_docente || 0,
      linkDrive: linkDrive.trim()
    }));
    logHistorial(sesionActiva.id_sesion, 'LINK_DRIVE_ACTUALIZADO', `Link Drive actualizado: ${linkDrive}`);
    setEditDrive(false);
    setTimeout(() => { refrescar(); cargarHistorial(sesionActiva.id_sesion); }, 600);
  };

  const handleToggleCalidad = (c) => {
    const idKey = c.id_dt_calidad_sesion || c.id_dt_estado_sesion;
    const nuevoEstado = c.estado === 'Completo' ? 'Incompleto' : 'Completo';
    dispatch(actualizarEstadoAjuste(idProyecto, c.estado, idKey));
    logHistorial(sesionActiva.id_sesion, 'ACCION_MEJORA', `${c.nombre_proceso || c.ajuste || c.nombre_ajuste || 'Acción'} marcada como ${nuevoEstado}`);
    setTimeout(() => cargarHistorial(sesionActiva.id_sesion), 400);
  };

  const handleEstadoCapacitacion = (idFiltroDocente, idEstado) => {
    const est = ESTADOS_CAPACITACION.find(e => e.id === idEstado);
    dispatch(cambiarEstadoDocente(idFiltroDocente, idEstado, idProyecto));
    logHistorial(sesionActiva.id_sesion, 'ESTADO_CAPACITACION', `Estado ANDRO cambiado a: ${est ? est.label : idEstado}`);
    setTimeout(refrescar, 600);
  };

  // ── Tabla principal ───────────────────────────────────────────────────────

  const renderTabla = () => (
    <div style={{ overflowX: 'auto' }}>
      <table className="table table-bordered table-hover table-sm mb-0" style={{ fontSize: '14px' }}>
        <thead style={{ backgroundColor: '#262F48', color: '#fff' }}>
          <tr>
            <th className="text-center" style={{ width: 70 }}>
              <div style={{ display: 'flex', justifyContent: 'center', gap: 6 }}>
                {[
                  { key: 'VERDE', color: COLOR_SEMAFORO.VERDE, cnt: cntVerde },
                  { key: 'AMBAR', color: COLOR_SEMAFORO.AMBAR, cnt: cntAmbar },
                  { key: 'ROJO',  color: COLOR_SEMAFORO.ROJO,  cnt: cntRojo  },
                ].map(({ key, color, cnt }) => (
                  <span
                    key={key}
                    onClick={() => setFiltroSemaforo(filtroSemaforo === key ? 'todos' : key)}
                    title={`${LABEL_SEMAFORO[key]}: ${cnt}`}
                    style={{
                      cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 2,
                      fontSize: 10, opacity: cnt === 0 ? 0.35 : 1,
                      fontWeight: filtroSemaforo === key ? 'bold' : 'normal',
                      borderBottom: filtroSemaforo === key ? `2px solid ${color}` : '2px solid transparent',
                      paddingBottom: 1,
                    }}
                  >
                    <FontAwesomeIcon icon={faCircle} style={{ color, fontSize: 9 }} />
                    {cnt}
                  </span>
                ))}
              </div>
            </th>
            <th style={{ width: 80, cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('fecha_sesion')}>
              Fecha {sortCol === 'fecha_sesion' ? (sortDir === 'asc' ? '▲' : '▼') : <span style={{ opacity: 0.3 }}>▲▼</span>}
            </th>
            <th>Módulo</th>
            <th>Sesión</th>
            <th>Docente</th>
            <th className="text-center" style={{ width: 110 }}>Estado Doc.</th>
            <th className="text-center" style={{ width: 90, cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('avance')}>
              Recursos {sortCol === 'avance' ? (sortDir === 'asc' ? '▲' : '▼') : <span style={{ opacity: 0.3 }}>▲▼</span>}
            </th>
            <th className="text-center" style={{ width: 80, cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('calificacion')}>
              Calif. {sortCol === 'calificacion' ? (sortDir === 'asc' ? '▲' : '▼') : <span style={{ opacity: 0.3 }}>▲▼</span>}
            </th>
            <th className="text-center" style={{ width: 55 }}>Ver</th>
          </tr>
        </thead>
        <tbody>
          {sesionesFiltradas.length === 0 ? (
            <tr>
              <td colSpan={9} className="text-center text-muted py-4">
                Sin sesiones para mostrar
              </td>
            </tr>
          ) : sesionesFiltradas.map((s, i) => {
            const sem    = calcularSemaforo(s);
            const avance = calcularAvance(s.proceso);
            const docNom = s.docente_confirmado?.[0]
              ? `${s.docente_confirmado[0].nombre_usuario} ${s.docente_confirmado[0].apellido_usuario}`
              : s.docentes_tentativos?.[0]
                ? `${s.docentes_tentativos[0].nombre_usuario} ${s.docentes_tentativos[0].apellido_usuario}`
                : '—';

            return (
              <tr key={i}>
                <td className="text-center" title={LABEL_SEMAFORO[sem]}>
                  <FontAwesomeIcon icon={faCircle} style={{ color: COLOR_SEMAFORO[sem], fontSize: 15 }} />
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {s.fecha_sesion ? moment(s.fecha_sesion).format('DD/MM/YY') : '—'}
                </td>
                <td style={{ minWidth: 130 }}>
                  {s.nombre_modulo || '—'}
                </td>
                <td style={{ minWidth: 170 }}>
                  {s.nombre_sesion || '—'}
                </td>
                <td style={{ minWidth: 130 }}>
                  {docNom}
                </td>
                <td className="text-center">{badgeDocente(s)}</td>
                <td className="text-center">
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4, justifyContent: 'center' }}>
                    <div style={{ width: 56, height: 8, background: '#e9ecef', borderRadius: 4, overflow: 'hidden' }}>
                      <div style={{
                        width: `${avance}%`, height: '100%', borderRadius: 4,
                        background: avance === 100 ? '#18BB60' : avance >= 60 ? '#F39C12' : '#E12E1C'
                      }} />
                    </div>
                    <span style={{ fontSize: 12, minWidth: 30 }}>{avance}%</span>
                  </div>
                </td>
                <td className="text-center">
                  {isNaN(s.calificacion) || s.calificacion === null ? '—' : `${parseFloat(s.calificacion).toFixed(1)}`}
                </td>
                <td className="text-center">
                  <Button size="sm" variant="outline-primary" style={{ padding: '2px 8px' }} onClick={() => abrirDetalle(s)}>
                    <FontAwesomeIcon icon={faEye} />
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  // ── Tab 1: Datos ──────────────────────────────────────────────────────────

  const renderDatos = () => {
    const s = sesionActiva;
    if (!s) return null;
    const sem = calcularSemaforo(s);
    return (
      <div className="p-3">
        <Row>
          <Col md={6}>
            <table className="table table-sm table-borderless" style={{ fontSize: 13 }}>
              <tbody>
                <tr><td><strong>Producto</strong></td><td>{nombreProducto || '—'}</td></tr>
                <tr><td><strong>Módulo</strong></td><td>{s.nombre_modulo || '—'}</td></tr>
                <tr><td><strong>Sesión</strong></td><td>{s.nombre_sesion || '—'}</td></tr>
                <tr><td><strong>Fecha</strong></td><td>{s.fecha_sesion ? moment(s.fecha_sesion).format('DD/MM/YYYY') : '—'}</td></tr>
                {s.horas_sesion && <tr><td><strong>Horas</strong></td><td>{s.horas_sesion} hrs</td></tr>}
                {s.hora_ingreso_tur_m && <tr><td><strong>Horario mañana</strong></td><td>{s.hora_ingreso_tur_m} – {s.hora_salida_tur_m}</td></tr>}
                {s.hora_ingreso_tur_t && <tr><td><strong>Horario tarde</strong></td><td>{s.hora_ingreso_tur_t} – {s.hora_salida_tur_t}</td></tr>}
                <tr>
                  <td><strong>Semáforo</strong></td>
                  <td>
                    <FontAwesomeIcon icon={faCircle} style={{ color: COLOR_SEMAFORO[sem], marginRight: 6 }} />
                    {LABEL_SEMAFORO[sem]}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col md={6}>
            <table className="table table-sm table-borderless" style={{ fontSize: 13 }}>
              <tbody>
                <tr>
                  <td><strong>Link clase online</strong></td>
                  <td>
                    {s.ruta_archivo
                      ? <a href={s.ruta_archivo} target="_blank" rel="noopener noreferrer">Ver link</a>
                      : <span className="text-muted">Sin link</span>}
                  </td>
                </tr>
                <tr>
                  <td><strong>Carpeta Drive</strong></td>
                  <td>
                    {!editDrive ? (
                      <>
                        {s.link_drive
                          ? <a href={s.link_drive} target="_blank" rel="noopener noreferrer">Ver carpeta</a>
                          : <span className="text-muted">Sin link</span>}
                        {' '}
                        <Button size="sm" variant="link" style={{ fontSize: 11, padding: 0 }} onClick={() => setEditDrive(true)}>
                          Editar
                        </Button>
                      </>
                    ) : (
                      <div className="d-flex mt-1" style={{ gap: 4 }}>
                        <Form.Control
                          size="sm"
                          value={linkDrive}
                          onChange={e => setLinkDrive(e.target.value)}
                          placeholder="Pegar enlace de Drive aquí..."
                        />
                        <Button size="sm" variant="success" onClick={handleGuardarDrive}>OK</Button>
                        <Button size="sm" variant="outline-secondary" onClick={() => setEditDrive(false)}>X</Button>
                      </div>
                    )}
                  </td>
                </tr>
                <tr>
                  <td><strong>Avance recursos</strong></td>
                  <td>
                    {(() => {
                      const av = calcularAvance(s.proceso);
                      return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div style={{ width: 80, height: 8, background: '#e9ecef', borderRadius: 4, overflow: 'hidden' }}>
                            <div style={{
                              width: `${av}%`, height: '100%', borderRadius: 4,
                              background: av === 100 ? '#18BB60' : av >= 60 ? '#F39C12' : '#E12E1C'
                            }} />
                          </div>
                          <span style={{ fontSize: 12 }}><strong>{av}%</strong></span>
                        </div>
                      );
                    })()}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </div>
    );
  };

  // ── Tab 2: Docente ────────────────────────────────────────────────────────

  const renderDocente = () => {
    const s = sesionActiva;
    if (!s) return null;
    return (
      <div className="p-3">
        {/* Confirmado */}
        {s.docente_confirmado && s.docente_confirmado.length > 0 && (
          <div className="mb-3 p-2 border rounded" style={{ borderLeft: '4px solid #18BB60 !important' }}>
            <div className="mb-1"><Badge variant="success"><FontAwesomeIcon icon={faCheck} className="mr-1" />Confirmado</Badge></div>
            {s.docente_confirmado.map((d, i) => (
              <div key={i}>
                <p className="mb-1" style={{ fontSize: 13 }}><strong>{d.nombre_usuario} {d.apellido_usuario}</strong></p>
                {d.correo  && <p className="mb-1 text-muted" style={{ fontSize: 11 }}><FontAwesomeIcon icon={faEnvelope} className="mr-1" />{d.correo}</p>}
                {d.celular && <p className="mb-1 text-muted" style={{ fontSize: 11 }}><FontAwesomeIcon icon={faMobileAlt} className="mr-1" />{d.celular}</p>}
                {d.cv       && <p className="mb-1" style={{ fontSize: 11 }}>
                  <a href={`${process.env.REACT_APP_API_URL}/${d.cv}`} target="_blank" rel="noopener noreferrer">Ver CV</a>
                </p>}
              </div>
            ))}
          </div>
        )}

        {/* Tentativos */}
        {s.docentes_tentativos && s.docentes_tentativos.length > 0 && (
          <div className="mb-3">
            <p className="mb-1" style={{ fontSize: 12 }}><strong>Docentes tentativos:</strong></p>
            {s.docentes_tentativos.map((d, i) => (
              <div key={i} className="d-flex justify-content-between align-items-center mb-1 p-2 border rounded">
                <span style={{ fontSize: 12 }}>{d.nombre_usuario} {d.apellido_usuario}</span>
                <div style={{ display: 'flex', gap: 4 }}>
                  <Button size="sm" variant="success" onClick={() => handleConfirmar(d.id_filtro_sesion)}>
                    Confirmar
                  </Button>
                  <Button size="sm" variant="outline-danger" onClick={() => handleEliminarDocente(d.id_filtro_sesion, `${d.nombre_usuario} ${d.apellido_usuario}`)}>
                    Quitar
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Acciones de calidad docente */}
        {s.docente_confirmado && s.docente_confirmado.length > 0 && (
          <div className="mb-3 pt-2 border-top">
            <p className="mb-2" style={{ fontSize: 11, color: '#666' }}><strong>Acciones de calidad docente:</strong></p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              <Button size="sm" variant="outline-warning"
                onClick={handleCambiarDocente}
                title="Quita al docente confirmado para asignar uno nuevo">
                <FontAwesomeIcon icon={faUserSlash} className="mr-1" />Cambiar docente
              </Button>
              <Button size="sm" variant="outline-danger"
                onClick={handleTerminarContrato}
                title="Termina el contrato con el docente confirmado">
                <FontAwesomeIcon icon={faHandshake} className="mr-1" />Terminar contrato
              </Button>
              <Button size="sm" variant="outline-info"
                onClick={() => setTabActiva('capacitacion')}
                title="Ir a la pestaña de capacitación para registrar el estado ANDRO">
                <FontAwesomeIcon icon={faGraduationCap} className="mr-1" />Capacitar docente
              </Button>
              <Button size="sm" variant="outline-success"
                onClick={() => setShowMotivar(true)}
                title="Registrar una nota de motivación en el historial">
                <FontAwesomeIcon icon={faHeartbeat} className="mr-1" />Motivar docente
              </Button>
            </div>
          </div>
        )}

        {!s.docente_confirmado?.length && !s.docentes_tentativos?.length && (
          <p className="text-muted" style={{ fontSize: 12 }}>Sin docentes asignados a esta sesión.</p>
        )}

        {/* Asignar docente tentativo */}
        {!s.docente_confirmado?.length && (
          <div className="mb-3">
            <p className="mb-1" style={{ fontSize: 12 }}><strong>Agregar docente tentativo:</strong></p>
            <Form.Control
              size="sm"
              placeholder="Buscar por nombre..."
              value={buscarDocente}
              onChange={e => setBuscarDocente(e.target.value)}
              className="mb-2"
            />
            <div style={{ maxHeight: 160, overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: 4 }}>
              {docentesFiltro
                .filter(d => {
                  const nombre = `${d.nombre_usuario} ${d.apellido_usuario}`.toLowerCase();
                  return !buscarDocente || nombre.includes(buscarDocente.toLowerCase());
                })
                .filter(d => {
                  const yaEsTentativo = s.docentes_tentativos?.some(t => t.id_filtro_docente === d.id_filtro_docente);
                  return !yaEsTentativo;
                })
                .map((d, i) => (
                  <div key={i} className="d-flex justify-content-between align-items-center px-2 py-1"
                    style={{ borderBottom: '1px solid #f0f0f0', fontSize: 12 }}>
                    <span>{d.nombre_usuario} {d.apellido_usuario}</span>
                    <Button size="sm" variant="outline-primary" style={{ fontSize: 10, padding: '1px 8px' }}
                      onClick={() => {
                        dispatch(guardarPonenteTentativo(
                          s.id_sesion,
                          d.id_filtro_docente,
                          s.id_reporte_control_capacitacion,
                          idProyecto
                        ));
                        setBuscarDocente('');
                        setTimeout(refrescar, 600);
                      }}>
                      + Tentativo
                    </Button>
                  </div>
                ))
              }
              {docentesFiltro.length === 0 && (
                <p className="text-muted p-2 mb-0" style={{ fontSize: 11 }}>
                  No hay docentes asignados a este producto.
                </p>
              )}
            </div>
          </div>
        )}

        {/* Evidencia de confirmación */}
        <div className="mt-3 pt-3 border-top">
          <p className="mb-2" style={{ fontSize: 12 }}><strong>Evidencia de confirmación (correo/contrato):</strong></p>
          {s.archivo_confirmacion && s.archivo_confirmacion.length > 0 ? (
            s.archivo_confirmacion.map((a, i) => (
              <div key={i} className="d-flex align-items-center mb-1" style={{ gap: 8 }}>
                <a href={`${process.env.REACT_APP_API_URL}/${a.ruta_archivo}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12 }}>
                  <FontAwesomeIcon icon={faPaperclip} className="mr-1" />Archivo {i + 1}
                </a>
                <a href={`${process.env.REACT_APP_API_URL}/${a.ruta_archivo}`} target="_blank" rel="noopener noreferrer">
                  <Button size="sm" variant="outline-info" style={{ fontSize: 10, padding: '1px 6px' }}>
                    <FontAwesomeIcon icon={faEye} className="mr-1" />Ver
                  </Button>
                </a>
                <Button size="sm" variant="outline-danger" style={{ fontSize: 10, padding: '1px 6px' }}
                  onClick={() => dispatch(eliminarImagen(a.id_archivo_confirmacion, idProyecto)).then(refrescar)}>
                  Eliminar
                </Button>
              </div>
            ))
          ) : (
            <p className="text-muted" style={{ fontSize: 11 }}>Sin evidencia adjunta.</p>
          )}
          <input type="file" ref={refConfirmacion} style={{ display: 'none' }}
            onChange={handleSubirConfirmacion} accept="image/*,.pdf" />
          <Button size="sm" variant="outline-primary" className="mt-1" onClick={() => refConfirmacion.current.click()}>
            <FontAwesomeIcon icon={faUpload} className="mr-1" />Adjuntar evidencia
          </Button>
        </div>
      </div>
    );
  };

  // ── Tab 3: Capacitación ───────────────────────────────────────────────────

  const renderCapacitacion = () => {
    const s = sesionActiva;
    if (!s) return null;
    const docConf = s.docente_confirmado?.[0];
    if (!docConf) {
      return (
        <div className="p-3">
          <p className="text-muted" style={{ fontSize: 12 }}>
            Primero confirma un docente en la pestaña <strong>Docente</strong>.
          </p>
        </div>
      );
    }
    return (
      <div className="p-3">
        <p style={{ fontSize: 13 }}>
          <strong>Docente:</strong> {docConf.nombre_usuario} {docConf.apellido_usuario}
        </p>

        <p className="mb-1" style={{ fontSize: 12 }}><strong>Estado de capacitación ANDRO®:</strong></p>
        <div className="d-flex mb-3" style={{ gap: 8 }}>
          {ESTADOS_CAPACITACION.map(est => (
            <Button
              key={est.id}
              size="sm"
              variant={s.id_estado_capacitacion === est.id ? est.variant : `outline-${est.variant}`}
              onClick={() => handleEstadoCapacitacion(docConf.id_filtro_docente, est.id)}
            >
              {est.label}
            </Button>
          ))}
        </div>

        <p className="mb-1" style={{ fontSize: 12 }}><strong>Evidencias de capacitación:</strong></p>
        {s.archivo_evidencia && s.archivo_evidencia.length > 0 ? (
          s.archivo_evidencia.map((a, i) => (
            <div key={i} className="d-flex align-items-center mb-1" style={{ gap: 8 }}>
              <a href={`${process.env.REACT_APP_API_URL}/${a.ruta_archivo}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12 }}>
                <FontAwesomeIcon icon={faPaperclip} className="mr-1" />Evidencia {i + 1}
              </a>
              <a href={`${process.env.REACT_APP_API_URL}/${a.ruta_archivo}`} target="_blank" rel="noopener noreferrer">
                <Button size="sm" variant="outline-info" style={{ fontSize: 10, padding: '1px 6px' }}>
                  <FontAwesomeIcon icon={faEye} className="mr-1" />Ver
                </Button>
              </a>
              <Button size="sm" variant="outline-danger" style={{ fontSize: 10, padding: '1px 6px' }}
                onClick={() => dispatch(eliminarEvidencia(a.id_archivo_confirmacion, idProyecto)).then(refrescar)}>
                Eliminar
              </Button>
            </div>
          ))
        ) : (
          <p className="text-muted" style={{ fontSize: 11 }}>Sin evidencia de capacitación.</p>
        )}
        <input type="file" ref={refEvidCap} style={{ display: 'none' }}
          onChange={handleSubirEvidencia} accept="image/*,.pdf" />
        <Button size="sm" variant="outline-primary" className="mt-1" onClick={() => refEvidCap.current.click()}>
          <FontAwesomeIcon icon={faUpload} className="mr-1" />Adjuntar evidencia
        </Button>
      </div>
    );
  };

  // ── Tab 4: Recursos ───────────────────────────────────────────────────────

  const renderRecursos = () => {
    const proceso   = sesionActiva?.proceso || [];
    const recursos  = proceso.filter(p => !NO_CUENTA.includes(p.nombre_proceso));
    const actividad = proceso.filter(p =>  NO_CUENTA.includes(p.nombre_proceso));
    const avance    = calcularAvance(proceso);

    return (
      <div className="p-3">
        {/* Barra de avance */}
        <div className="d-flex align-items-center mb-2" style={{ gap: 10 }}>
          <span style={{ fontSize: 12 }}><strong>Avance:</strong></span>
          <div style={{ width: 130, height: 10, background: '#e9ecef', borderRadius: 5, overflow: 'hidden' }}>
            <div style={{
              width: `${avance}%`, height: '100%', borderRadius: 5,
              background: avance === 100 ? '#18BB60' : avance >= 60 ? '#F39C12' : '#E12E1C'
            }} />
          </div>
          <Badge variant={avance === 100 ? 'success' : avance >= 60 ? 'warning' : 'danger'}>
            {avance === 100 ? '100% Completo' : `${recursos.filter(r => r.estado === 'Completo').length}/5 — ${avance}%`}
          </Badge>
        </div>

        <p style={{ fontSize: 10, color: '#888' }} className="mb-2">
          Se calcula sobre 5 elementos: La clase Online, La clase Offline, Los Materiales, El Podcast y El Quiz. La Actividad no cuenta.
        </p>

        <table className="table table-sm table-bordered" style={{ fontSize: 12 }}>
          <thead style={{ backgroundColor: '#f8f9fa' }}>
            <tr>
              <th>Recurso</th>
              <th className="text-center" style={{ width: 120 }}>Estado</th>
            </tr>
          </thead>
          <tbody>
            {recursos.map((r, i) => (
              <tr key={i}>
                <td>{r.nombre_proceso}</td>
                <td className="text-center">
                  {r.estado === 'Completo'
                    ? <span className="badge badge-success" style={{ fontSize: 11 }}><FontAwesomeIcon icon={faCheck} className="mr-1" />Completo</span>
                    : <span className="badge badge-secondary" style={{ fontSize: 11 }}>Incompleto</span>
                  }
                </td>
              </tr>
            ))}
            {actividad.map((a, i) => (
              <tr key={'act' + i} style={{ backgroundColor: '#fafafa' }}>
                <td>
                  {a.nombre_proceso}
                  {' '}<Badge variant="secondary" style={{ fontSize: 9 }}>No cuenta</Badge>
                </td>
                <td className="text-center" style={{ color: '#666', fontSize: 11 }}>{a.estado}</td>
              </tr>
            ))}
            {proceso.length === 0 && (
              <tr><td colSpan={2} className="text-muted text-center">Sin recursos registrados</td></tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

  // ── Tab 5: Comunicación ───────────────────────────────────────────────────

  const renderComunicacion = () => {
    const s = sesionActiva;
    if (!s) return null;
    const docConf  = s.docente_confirmado?.[0];
    const fecha    = s.fecha_sesion ? moment(s.fecha_sesion).format('DD/MM/YYYY') : '—';
    const celular  = docConf?.celular || '';
    const nombreDoc = docConf ? `${docConf.nombre_usuario}` : '';

    const horario = s.hora_ingreso_tur_m
      ? `${s.hora_ingreso_tur_m} - ${s.hora_salida_tur_m}`
      : s.hora_ingreso_tur_t
      ? `${s.hora_ingreso_tur_t} - ${s.hora_salida_tur_t}`
      : 'Por confirmar';

    const msgRecordatorio = `Querido Prof. ${nombreDoc}, esperamos que se encuentre muy bien. 🌟\nCon mucho aprecio, le recordamos su sesión académica correspondiente al:\n📚 *${nombreProducto}*\n📌 Tema: ${s.nombre_sesion || ''}\n📅 Fecha: ${fecha}\n🕖 Horario: ${horario}\nLe agradeceremos ingresar con 15 minutos de anticipación, a fin de validar su acceso, audio, cámara y recursos antes del inicio de la clase.\n🔗 Link de clase:\n${s.ruta_archivo || 'Por confirmar'}\n📁 Materiales institucionalizados con membrete INEDI:\n${s.link_drive || 'Por confirmar'}\nAsimismo, le recomendamos revisar las indicaciones para profesores en la siguiente página:\n🔗 https://inedi.edu.pe/profesores/\nAgradecemos mucho su valiosa participación, su disposición y el compromiso académico que siempre brinda a nuestros estudiantes.`;
    const msgMateriales   = `Querido Prof. ${nombreDoc}, esperamos que se encuentre muy bien. 🌟\nCon mucho aprecio, le recordamos por favor subir sus materiales académicos en la siguiente carpeta, para que puedan ser revisados e institucionalizados con el membrete de INEDI antes de la sesión:\n📚 *${nombreProducto}*\n📌 Tema: ${s.nombre_sesion || ''}\n📅 Fecha: ${fecha}\n🕖 Horario: ${horario}\n📁 Carpeta para carga de materiales:\n${s.link_drive || 'Por confirmar'}\nAsimismo, puede revisar las recomendaciones y el tipo de recursos académicos requeridos en la siguiente página:\n🔗 https://inedi.edu.pe/profesores/\nAgradecemos profundamente su dedicación y el valioso aporte académico que brinda al programa.`;
    const msgConfirmacion = `Querido Prof. ${nombreDoc}, esperamos que se encuentre muy bien. 🌟\nCon mucho aprecio y respeto, deseamos consultarle si nos podría confirmar su disponibilidad para la sesión académica del:\n📚 *${nombreProducto}*\n📌 Tema: ${s.nombre_sesion || ''}\n📅 Fecha: ${fecha}\n🕖 Horario: ${horario}\nSerá un honor contar con su presencia y guía académica en esta importante sesión.\nAgradecemos mucho su confirmación.`;

    const waLink = (msg) => `https://wa.me/51${celular}?text=${encodeURIComponent(msg)}`;

    return (
      <div className="p-3">
        <p style={{ fontSize: 11, color: '#666' }} className="mb-3">
          Los botones abren WhatsApp Web con el mensaje pre-cargado para el docente confirmado.
        </p>

        <p className="mb-2" style={{ fontSize: 12 }}><strong>Mensajes rápidos:</strong></p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
          <Button variant="success" size="sm" disabled={!celular}
            onClick={() => window.open(waLink(msgConfirmacion), '_blank')}>
            <FontAwesomeIcon icon={faCommentDots} style={{ marginRight: 6 }} />
            Solicitar confirmación de docente
          </Button>
          <Button variant="success" size="sm" disabled={!celular}
            onClick={() => window.open(waLink(msgMateriales), '_blank')}>
            <FontAwesomeIcon icon={faCommentDots} style={{ marginRight: 6 }} />
            Recordar carga de materiales
          </Button>
          <Button variant="success" size="sm" disabled={!celular}
            onClick={() => window.open(waLink(msgRecordatorio), '_blank')}>
            <FontAwesomeIcon icon={faCommentDots} style={{ marginRight: 6 }} />
            Enviar recordatorio de clase
          </Button>
        </div>

        {s.fecha_sesion && (
          <div className="border rounded p-2" style={{ fontSize: 11 }}>
            <p className="mb-1"><strong><FontAwesomeIcon icon={faClock} style={{ marginRight: 4 }} />Días antes de la sesión:</strong></p>
            {[
              { dias: 7,  label: '7 días antes' },
              { dias: 3,  label: '3 días antes' },
              { dias: 1,  label: '24 horas antes' },
            ].map(({ dias, label }) => {
              const fechaSesion = moment(s.fecha_sesion).startOf('day');
              const hoy         = moment().startOf('day');
              const diff        = fechaSesion.diff(hoy, 'days');
              const esHoy       = diff >= 0 && diff < dias;
              return (
                <div key={dias} className="d-flex justify-content-between align-items-center py-1 border-bottom">
                  <span>{label}</span>
                  <Badge variant={esHoy ? 'warning' : diff < 0 ? 'secondary' : 'info'}>
                    {diff < 0 ? 'Pasada' : diff === 0 ? 'Hoy' : `en ${diff} día${diff !== 1 ? 's' : ''}`}
                  </Badge>
                </div>
              );
            })}
          </div>
        )}

        {s.ruta_archivo && (
          <div className="mt-3" style={{ display: 'flex', gap: 8 }}>
            <Button variant="outline-primary" size="sm"
              onClick={() => { navigator.clipboard.writeText(s.ruta_archivo); avisoCorrecto('Link copiado'); }}>
              <FontAwesomeIcon icon={faCopy} className="mr-1" />Copiar link de clase
            </Button>
          </div>
        )}
        {s.link_drive && (
          <div className="mt-2" style={{ display: 'flex', gap: 8 }}>
            <Button variant="outline-secondary" size="sm"
              onClick={() => { navigator.clipboard.writeText(s.link_drive); avisoCorrecto('Link copiado'); }}>
              <FontAwesomeIcon icon={faCopy} className="mr-1" />Copiar carpeta Drive
            </Button>
          </div>
        )}

        {!celular && docConf && (
          <p className="text-warning mt-3" style={{ fontSize: 11 }}>
            <FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" />El docente no tiene número de celular registrado.
          </p>
        )}
        {!docConf && (
          <p className="text-muted mt-3" style={{ fontSize: 11 }}>
            Confirma un docente para habilitar los mensajes de WhatsApp.
          </p>
        )}
      </div>
    );
  };

  // ── Tab 6: Calidad ────────────────────────────────────────────────────────

  const renderCalidad = () => {
    const s      = sesionActiva;
    if (!s) return null;
    const calidad = s.calidad || [];
    const calif   = s.calificacion;

    return (
      <div className="p-3">
        {/* Calificación */}
        <div className="mb-3 p-2 border rounded text-center" style={{ maxWidth: 200 }}>
          <p className="mb-0" style={{ fontSize: 11, color: '#666' }}>Última calificación docente</p>
          <p className="mb-0" style={{ fontSize: 28, fontWeight: 'bold', color: !isNaN(calif) && calif !== null ? '#18BB60' : '#ccc' }}>
            {!isNaN(calif) && calif !== null ? `${parseFloat(calif).toFixed(1)}` : '—'}
          </p>
          {!isNaN(calif) && calif !== null && (
            <p className="mb-0" style={{ fontSize: 10, color: '#888' }}>sobre 5.0</p>
          )}
        </div>

        {/* Acciones de mejora */}
        <p className="mb-2" style={{ fontSize: 12 }}><strong>Acciones de mejora:</strong></p>
        {calidad.length > 0 ? (
          <table className="table table-sm table-bordered" style={{ fontSize: 12 }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th>Acción</th>
                <th className="text-center" style={{ width: 120 }}>Estado</th>
              </tr>
            </thead>
            <tbody>
              {calidad.map((c, i) => (
                <tr key={i}>
                  <td>{c.nombre_proceso || c.ajuste || c.nombre_ajuste || '—'}</td>
                  <td className="text-center">
                    <Button
                      size="sm"
                      variant={c.estado === 'Completo' ? 'success' : 'outline-secondary'}
                      onClick={() => handleToggleCalidad(c)}
                      style={{ fontSize: 11, padding: '2px 8px' }}
                    >
                      {c.estado === 'Completo' ? <><FontAwesomeIcon icon={faCheck} className="mr-1" />Completada</> : 'Pendiente'}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-muted" style={{ fontSize: 12 }}>Sin acciones de mejora registradas.</p>
        )}

        {/* Evidencia de calidad */}
        <div className="mt-3 pt-2 border-top">
          <p className="mb-2" style={{ fontSize: 12 }}><strong>Evidencia de acciones de mejora:</strong></p>
          {s.archivo_evidencia && s.archivo_evidencia.length > 0 ? (
            s.archivo_evidencia.map((a, i) => (
              <div key={i} className="d-flex align-items-center mb-1" style={{ gap: 8 }}>
                <a href={`${process.env.REACT_APP_API_URL}/${a.ruta_archivo}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12 }}>
                  <FontAwesomeIcon icon={faPaperclip} className="mr-1" />Evidencia {i + 1}
                </a>
                <a href={`${process.env.REACT_APP_API_URL}/${a.ruta_archivo}`} target="_blank" rel="noopener noreferrer">
                  <Button size="sm" variant="outline-info" style={{ fontSize: 10, padding: '1px 6px' }}>
                    <FontAwesomeIcon icon={faEye} className="mr-1" />Ver
                  </Button>
                </a>
                <Button size="sm" variant="outline-danger" style={{ fontSize: 10, padding: '1px 6px' }}
                  onClick={() => dispatch(eliminarEvidencia(a.id_archivo_confirmacion, idProyecto)).then(refrescar)}>
                  Eliminar
                </Button>
              </div>
            ))
          ) : (
            <p className="text-muted" style={{ fontSize: 11 }}>Sin evidencia adjunta.</p>
          )}
          <input type="file" ref={refEvidCal} style={{ display: 'none' }}
            onChange={handleSubirEvidenciaCalidad} accept="image/*,.pdf" />
          <Button size="sm" variant="outline-primary" className="mt-1" onClick={() => refEvidCal.current.click()}>
            <FontAwesomeIcon icon={faUpload} className="mr-1" />Adjuntar evidencia
          </Button>
        </div>
      </div>
    );
  };

  // ── Tab 7: Historial ──────────────────────────────────────────────────────

  const ETIQUETA_TIPO = {
    DOCENTE_CONFIRMADO:      { label: 'Docente confirmado',      variant: 'success'   },
    DOCENTE_ELIMINADO:       { label: 'Docente eliminado',       variant: 'danger'    },
    CAMBIO_DOCENTE:          { label: 'Cambio de docente',       variant: 'warning'   },
    CONTRATO_TERMINADO:      { label: 'Contrato terminado',      variant: 'danger'    },
    MOTIVACION_DOCENTE:      { label: 'Motivación docente',      variant: 'info'      },
    EVIDENCIA_CONFIRMACION:  { label: 'Evidencia confirmación',  variant: 'primary'   },
    EVIDENCIA_CAPACITACION:  { label: 'Evidencia capacitación',  variant: 'primary'   },
    EVIDENCIA_CALIDAD:       { label: 'Evidencia calidad',       variant: 'info'      },
    ESTADO_CAPACITACION:     { label: 'Estado ANDRO',            variant: 'warning'   },
    RECURSO_ACTUALIZADO:     { label: 'Recurso actualizado',     variant: 'secondary' },
    LINK_DRIVE_ACTUALIZADO:  { label: 'Link Drive',              variant: 'secondary' },
    ACCION_MEJORA:           { label: 'Acción de mejora',        variant: 'info'      },
  };

  const renderHistorial = () => (
    <div className="p-3">
      {loadingHistorial ? (
        <p className="text-muted text-center py-3" style={{ fontSize: 12 }}>Cargando historial...</p>
      ) : historial.length === 0 ? (
        <p className="text-muted text-center py-3" style={{ fontSize: 12 }}>
          Sin registros aún. Los cambios se guardan automáticamente.
        </p>
      ) : (
        <div style={{ position: 'relative' }}>
          {historial.map((h, i) => {
            const tipo = ETIQUETA_TIPO[h.tipo_accion] || { label: h.tipo_accion, variant: 'secondary' };
            return (
              <div key={i} className="d-flex mb-3" style={{ gap: 10 }}>
                <div style={{
                  width: 10, height: 10, borderRadius: '50%', marginTop: 4, flexShrink: 0,
                  backgroundColor: tipo.variant === 'success' ? '#18BB60'
                    : tipo.variant === 'danger' ? '#E12E1C'
                    : tipo.variant === 'warning' ? '#F39C12'
                    : tipo.variant === 'info' ? '#17a2b8'
                    : tipo.variant === 'primary' ? '#262F48'
                    : '#aaa'
                }} />
                <div style={{ flex: 1 }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <Badge variant={tipo.variant} style={{ fontSize: 10 }}>{tipo.label}</Badge>
                    <span style={{ fontSize: 10, color: '#aaa' }}>
                      {moment(h.fecha_registro).format('DD/MM/YY HH:mm')}
                    </span>
                  </div>
                  {h.descripcion && (
                    <p className="mb-0 mt-1" style={{ fontSize: 11, color: '#444' }}>{h.descripcion}</p>
                  )}
                  <p className="mb-0" style={{ fontSize: 10, color: '#999' }}>
                    Por: {h.nombre_usuario || 'Sistema'}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="text-right mt-2">
        <Button size="sm" variant="outline-secondary" onClick={() => cargarHistorial(sesionActiva?.id_sesion)}>
          <FontAwesomeIcon icon={faSync} className="mr-1" />Actualizar
        </Button>
      </div>
    </div>
  );

  // ── Tab Docentes (nivel de página) ───────────────────────────────────────

  const renderDocentes = () => (
    <div className="box mt-2">
      <div className="p-3 d-flex justify-content-between align-items-center"
        style={{ borderBottom: '1px solid #eee' }}>
        <span style={{ fontWeight: '600', fontSize: 14 }}>
          <FontAwesomeIcon icon={faUsers} className="mr-2" />
          Docentes del producto ({docentesFiltro.length})
        </span>
        <Button size="sm" variant="info"
          onClick={() => dispatch(updateStateModalLarge(
            <ControlInsercionDocentesCapacitacion />, 'Docentes'
          ))}>
          <FontAwesomeIcon icon={faPlus} className="mr-1" />Agregar docente
        </Button>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="table table-bordered table-hover table-sm mb-0" style={{ fontSize: 13 }}>
          <thead style={{ backgroundColor: '#262F48', color: '#fff' }}>
            <tr>
              <th>Docente</th>
              <th className="text-center" style={{ width: 70 }}>Acciones</th>
              <th style={{ width: 180 }}>Clasificación</th>
              <th className="text-center" style={{ width: 110 }}>¿Puntual con materiales?</th>
              <th className="text-center" style={{ width: 110 }}>¿Envía materiales?</th>
              <th className="text-center" style={{ width: 100 }}></th>
            </tr>
          </thead>
          <tbody>
            {docentesFiltro.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center text-muted py-4">
                  No hay docentes asignados al producto
                </td>
              </tr>
            ) : (
              docentesFiltro.map(d => (
                <DocenteRow key={d.id_filtro_docente} docente={d} idProyecto={idProyecto} />
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  // ── Render principal ──────────────────────────────────────────────────────

  return (
    <Layout>
      <div className="ImplementacionDetalle">
        <div className="ImplementacionDetalle__container">
          <div className="ImplementacionDetalle__head">
            <HeaderContent title="Gestión de Sesiones" icon="tasks" />
            <Breadcrumb
              link={[
                { url: '/inicio',         nombre: 'Inicio',         icon: 'fas fa-home' },
                { url: '/gestion-sesiones', nombre: 'Gestión de Sesiones' },
                { url: '',                nombre: datos?.datos_proyecto?.nombre_proyecto || '...' },
              ]}
            />
          </div>

          {/* Tabs de página */}
          <ul className="nav nav-tabs mt-2" style={{ borderBottom: '2px solid #262F48' }}>
            <li className="nav-item">
              <button
                className={`nav-link ${paginaActiva === 'sesiones' ? 'active' : ''}`}
                onClick={() => setPaginaActiva('sesiones')}
                style={{ border: 'none', background: 'none', cursor: 'pointer',
                  fontWeight: paginaActiva === 'sesiones' ? '600' : 'normal' }}
              >
                <FontAwesomeIcon icon={faTasks} className="mr-1" />Sesiones
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${paginaActiva === 'docentes' ? 'active' : ''}`}
                onClick={() => setPaginaActiva('docentes')}
                style={{ border: 'none', background: 'none', cursor: 'pointer',
                  fontWeight: paginaActiva === 'docentes' ? '600' : 'normal' }}
              >
                <FontAwesomeIcon icon={faUsers} className="mr-1" />Docentes ({docentesFiltro.length})
              </button>
            </li>
          </ul>

          {paginaActiva === 'sesiones' && <>
          {/* Filtros */}
          <div className="box p-3 mt-2">
            <Row className="align-items-end">
              <Col md={2}>
                <Form.Label style={{ fontSize: 11 }}>Estado docente</Form.Label>
                <Form.Control as="select" size="sm" value={filtroEstadoDoc}
                  onChange={e => setFiltroEstadoDoc(e.target.value)}>
                  <option value="todos">Todos</option>
                  <option value="confirmado">Confirmado</option>
                  <option value="tentativo">Tentativo</option>
                  <option value="sin_docente">Sin docente</option>
                </Form.Control>
              </Col>
              <Col md={2}>
                <Form.Label style={{ fontSize: 11 }}>Recursos</Form.Label>
                <Form.Control as="select" size="sm" value={filtroAvance}
                  onChange={e => setFiltroAvance(e.target.value)}>
                  <option value="todos">Todos</option>
                  <option value="completo">100% completo</option>
                  <option value="incompleto">Incompleto</option>
                  <option value="sin_avance">Sin avance (0%)</option>
                </Form.Control>
              </Col>
              <Col md={3}>
                <Form.Label style={{ fontSize: 11 }}>Buscar módulo, sesión o docente</Form.Label>
                <Form.Control size="sm" placeholder="Escribe para buscar..." value={filtroBusqueda}
                  onChange={e => setFiltroBusqueda(e.target.value)} />
              </Col>
              <Col md={2}>
                <Form.Label style={{ fontSize: 11 }}>Fecha desde</Form.Label>
                <Form.Control type="date" size="sm" value={filtroFechaDesde}
                  onChange={e => setFiltroFechaDesde(e.target.value)} />
              </Col>
              <Col md={2}>
                <Form.Label style={{ fontSize: 11 }}>Fecha hasta</Form.Label>
                <Form.Control type="date" size="sm" value={filtroFechaHasta}
                  onChange={e => setFiltroFechaHasta(e.target.value)} />
              </Col>
              <Col md={1} className="d-flex align-items-end" style={{ gap: 6 }}>
                <Button size="sm" variant="outline-secondary" onClick={refrescar} title="Refrescar">
                  <FontAwesomeIcon icon={faSync} />
                </Button>
                {(filtroSemaforo !== 'todos' || filtroEstadoDoc !== 'todos' || filtroAvance !== 'todos' ||
                  filtroBusqueda || filtroFechaDesde || filtroFechaHasta) && (
                  <Button size="sm" variant="outline-danger" onClick={() => {
                    setFiltroSemaforo('todos'); setFiltroEstadoDoc('todos');
                    setFiltroAvance('todos');
                    setFiltroBusqueda('');      setFiltroFechaDesde('');
                    setFiltroFechaHasta('');
                  }}>
                    Limpiar
                  </Button>
                )}
              </Col>
            </Row>
          </div>

          {/* Tabla */}
          <div className="box mt-2">
            <SpinnerLoading loading={loading}>
              <div style={{ fontSize: 13, color: '#666', padding: '6px 12px 0' }}>
                {sesionesFiltradas.length} sesión{sesionesFiltradas.length !== 1 ? 'es' : ''} mostrada{sesionesFiltradas.length !== 1 ? 's' : ''}
                {filtroSemaforo !== 'todos' || filtroBusqueda || filtroEstadoDoc !== 'todos' || filtroFechaDesde || filtroFechaHasta ? ' (filtrado)' : ''}
              </div>
              <div className="box-body p-0">
                {renderTabla()}
              </div>
            </SpinnerLoading>
          </div>
          </>}

          {paginaActiva === 'docentes' && renderDocentes()}
        </div>
      </div>

      {/* Modal detalle sesión */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton style={{ backgroundColor: '#262F48', color: '#fff', padding: '10px 16px' }}>
          <Modal.Title style={{ fontSize: 14 }}>
            <FontAwesomeIcon
              icon={faCircle}
              style={{ color: COLOR_SEMAFORO[calcularSemaforo(sesionActiva || {})], marginRight: 8 }}
            />
            {sesionActiva?.nombre_sesion || 'Detalle de sesión'}
            {sesionActiva?.nombre_modulo && (
              <span style={{ fontSize: 11, marginLeft: 8, opacity: 0.7 }}>— {sesionActiva.nombre_modulo}</span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, maxHeight: '72vh', overflowY: 'auto' }}>
          {sesionActiva && (
            <Tabs activeKey={tabActiva} onSelect={k => setTabActiva(k)} style={{ fontSize: 12 }}>
              <Tab eventKey="datos"        title={<span><FontAwesomeIcon icon={faInfoCircle}    className="mr-1" />Datos</span>}>        {renderDatos()}        </Tab>
              <Tab eventKey="docente"      title={<span><FontAwesomeIcon icon={faUser}          className="mr-1" />Docente</span>}>      {renderDocente()}      </Tab>
              <Tab eventKey="capacitacion" title={<span><FontAwesomeIcon icon={faGraduationCap} className="mr-1" />Capacitación</span>}> {renderCapacitacion()} </Tab>
              <Tab eventKey="recursos"     title={<span><FontAwesomeIcon icon={faTasks}         className="mr-1" />Recursos</span>}>     {renderRecursos()}     </Tab>
              <Tab eventKey="comunicacion" title={<span><FontAwesomeIcon icon={faComments}      className="mr-1" />Comunicación</span>}> {renderComunicacion()} </Tab>
              <Tab eventKey="calidad"      title={<span><FontAwesomeIcon icon={faStar}          className="mr-1" />Calidad</span>}>      {renderCalidad()}      </Tab>
              <Tab eventKey="historial"    title={<span><FontAwesomeIcon icon={faHistory}       className="mr-1" />Historial</span>}>    {renderHistorial()}    </Tab>
            </Tabs>
          )}
        </Modal.Body>
        <Modal.Footer style={{ padding: '8px 16px', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 11, color: '#666' }}>
            {sesionActiva?.fecha_sesion ? moment(sesionActiva.fecha_sesion).format('DD/MM/YYYY') : ''}
          </span>
          <Button variant="secondary" size="sm" onClick={() => setShowModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
      {/* Modal Motivar docente */}
      <Modal show={showMotivar} onHide={() => setShowMotivar(false)} size="sm" centered>
        <Modal.Header closeButton style={{ padding: '10px 16px' }}>
          <Modal.Title style={{ fontSize: 14 }}>
            <FontAwesomeIcon icon={faHeartbeat} className="mr-2" />Motivar docente
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label style={{ fontSize: 12 }}>Nota de motivación o reconocimiento:</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            size="sm"
            value={msgMotivar}
            onChange={e => setMsgMotivar(e.target.value)}
            placeholder="Ej: Excelente desempeño en la sesión anterior..."
          />
        </Modal.Body>
        <Modal.Footer style={{ padding: '8px 16px' }}>
          <Button size="sm" variant="secondary" onClick={() => setShowMotivar(false)}>Cancelar</Button>
          <Button size="sm" variant="success" onClick={handleMotivarDocente} disabled={!msgMotivar.trim()}>
            Registrar
          </Button>
        </Modal.Footer>
      </Modal>

    </Layout>
  );
};

export default ImplementacionDetalle;
